import { render, staticRenderFns } from "./PopupFilterDefaultLayout.vue?vue&type=template&id=2a731be3&scoped=true&"
import script from "./PopupFilterDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./PopupFilterDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a731be3",
  null
  
)

export default component.exports